export const makeEditPayload = (
  vehicle,

  cashCentersList,
  officeList
) => {
  let office = null;
  if (vehicle.officeId) {
    const officeIndex = officeList.findIndex(
      (elm) => elm.officeId === vehicle.officeId
    );
    if (officeIndex !== -1) {
      office = officeList[officeIndex];
    }
  }
  let cashCenter = null;
  if (vehicle.cashCenterId) {
    const index = cashCentersList.findIndex(
      (elm) => elm.cashCenterId === vehicle.cashCenterId
    );
    if (index !== -1) {
      cashCenter = cashCentersList[index];
    }
  }
  const _payload = {
    vehicleId: vehicle.id,
    cashCenterId: cashCenter,
    officeId: office,
    fleetNo: vehicle.fleetNo,
    registrationNo: vehicle.registrationNo,
    make: vehicle.make,
    model: vehicle.model,
    manufacturingYear: vehicle.manufacturingYear,
    vanType: { id: vehicle.vanType, text: vehicle.vanType },
    engineNo: vehicle.engineNo,
    chassisNo: vehicle.chassisNo,
    color: vehicle.color,
    city: { name: vehicle.city },
    purchaseDate: vehicle.purchaseDate ? new Date(vehicle.purchaseDate) : null,
    registrationType: {
      id: vehicle.registrationType,
      text: vehicle.registrationType,
    },
    registrationYear: vehicle.registrationYear,
    registrationExpiry: vehicle.registrationExpiry
      ? new Date(vehicle.registrationExpiry)
      : null,
    insurer: vehicle.insurer,
    insuranceExpiry: vehicle.insuranceExpiry
      ? new Date(vehicle.insuranceExpiry)
      : null,
    armouredBy: vehicle.armouredBy,
    armouringDate: vehicle.armouringDate
      ? new Date(vehicle.armouringDate)
      : null,
    lastFitnessDate: vehicle.lastFitnessDate
      ? new Date(vehicle.lastFitnessDate)
      : null,
    fitnessDueDate: vehicle.fitnessDueDate
      ? new Date(vehicle.fitnessDueDate)
      : null,
    fitnessInterval: vehicle.fitnessInterval,
    fuelTag: vehicle.fuelTag,
    cashLimit: vehicle.cashLimit,
    status: { id: vehicle.status, text: vehicle.status },
    issuedTo: vehicle.issuedTo,
    installedLocks: vehicle.installedLocks.map((elm) => ({
      lockType: elm.lockType,
      vender: elm.vender,
      lockSerilNo: elm.lockSerilNo,
    })),
    pictures: vehicle.pictures,
  };

  // console.log("_payload", _payload);
  return _payload;
};
